import { createStandaloneToast } from "@chakra-ui/react";
import theme from "theme";

const { toast: showToast, ToastContainer } = createStandaloneToast({ theme });

export { showToast, ToastContainer };
